import React from 'react';
import PropTypes from 'prop-types';
import { Row, Text } from '../../../../../../components/common';
import { cleanOrderId } from '../../../../../../utils/misc';

export const DrawerTitleLegacy = ({ isBipickingGroup, orderId }) => {
    const titleStyles = {
        borderBottom: '4px solid #a4c735',
        justifyContent: 'center',
        padding: 10,
        marginTop: 20,
        backgroundColor: 'white'
    };

    const titleText = isBipickingGroup
        ? 'Auditoría órdenes bipicking'
        : `Auditoría pedido ${cleanOrderId(orderId)}`;

    return (
        <Row style={titleStyles} justify='center'>
            <Text text={titleText} size={15} strong />
        </Row>
    );
};

DrawerTitleLegacy.propTypes = {
    isBipickingGroup: PropTypes.bool.isRequired,
    orderId: PropTypes.string
};